






















































import dateFns from 'date-fns';
import { Component, Vue, Prop } from 'vue-property-decorator';

import TeamLogo from '@/components/common/team-logo/TeamLogo.vue';
import FutsalActivities from '@/components/futsal/FutsalActivities.vue';
import { isFixturePlayed, isFixtureCancelled } from '@/services/FixtureService';
import { FixtureInterface, TeamInterface, ActivityInterface } from '@/interfaces/interfaces';

@Component({
  components: { TeamLogo, FutsalActivities }
})
export default class FutsalScoreModal extends Vue {
  @Prop() public triggerShowModal!: any;

  @Prop({ default: false }) private showModal!: boolean;
  @Prop({ default: null }) private fixture!: FixtureInterface;

  public close() {
    this.triggerShowModal(false);
  }

  public doNothing(e: any) {
    e.stopPropagation();
  }

  public isTeamWinner(team: TeamInterface) {
    const winnerTeam =
      this.fixture && this.fixture.homeTeamScore > this.fixture.awayTeamScore
        ? this.fixture && this.fixture.homeTeam
        : this.fixture && this.fixture.awayTeam;

    return winnerTeam && team.id === winnerTeam.id;
  }

  public getWinnerClassObject(team: TeamInterface) {
    return this.isFixturePlayed && this.isTeamWinner(team) ? { 'winner-team': true } : {};
  }

  get isFixturePlayed() {
    return isFixturePlayed(this.fixture);
  }

  get isFixtureCancelled() {
    return isFixtureCancelled(this.fixture);
  }

  get fixtureDate() {
    return this.fixture && dateFns.format(new Date(this.fixture.date), 'dddd MMM D, YYYY, hh:mm A');
  }
}
